import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WeeklyComponent } from './weekly/weekly.component';
import { TeacherComponent } from './teacher/teacher.component';
import { ClassComponent } from './class/class.component';
import { HomeComponent } from './home/home.component';
import { DailyActivityComponent } from './daily-activity/daily-activity.component';
import { CaseDailyActivityComponent } from './case-daily-activity/case-daily-activity.component';
import { UserAuthComponent } from './user-auth/user-auth.component';
import { TeacherLackComponent } from './teacher-lack/teacher-lack.component';
import { TeacherLackReportComponent } from './teacher-lack-report/teacher-lack-report.component';
import { CaseMasterComponent } from './case-master/case-master.component';

import { OnlyLoggedInUsersGuardService } from './only-logged-in-users-guard.service';

const routes: Routes = [
    { path: "", redirectTo: "/home", pathMatch: "full" },
    { path: "home", component: HomeComponent, canActivate: [OnlyLoggedInUsersGuardService]},
    { path: "case-list", component: CaseDailyActivityComponent, canActivate: [OnlyLoggedInUsersGuardService] },
    { path: "daily-activity/:id/:name", component: DailyActivityComponent, canActivate: [OnlyLoggedInUsersGuardService] },
    { path: "weekly/:day", component: WeeklyComponent, canActivate: [OnlyLoggedInUsersGuardService] },
    { path: "weekly", component: WeeklyComponent, canActivate: [OnlyLoggedInUsersGuardService] },
    { path: "teacher/:teacher/:type", component: TeacherComponent, canActivate: [OnlyLoggedInUsersGuardService] },
    { path: "class/:class", component: ClassComponent, canActivate: [OnlyLoggedInUsersGuardService] },
    { path: "class/:class/:exit", component: ClassComponent, canActivate: [OnlyLoggedInUsersGuardService] },
    { path: "login", component: UserAuthComponent, canActivate: [OnlyLoggedInUsersGuardService] },
    { path: "login/:account", component: UserAuthComponent, canActivate: [OnlyLoggedInUsersGuardService] },
    { path: "teacher-lack", component: TeacherLackComponent, canActivate: [OnlyLoggedInUsersGuardService] },
    { path: "teacher-lack/:epoch/:day/:wk", component: TeacherLackComponent, canActivate: [OnlyLoggedInUsersGuardService] },
    { path: "report/:type", component: TeacherLackReportComponent, canActivate: [OnlyLoggedInUsersGuardService] },
    { path: "report/:type/:month", component: TeacherLackReportComponent, canActivate: [OnlyLoggedInUsersGuardService] },
    { path: "case-master/:id", component: CaseMasterComponent, canActivate: [OnlyLoggedInUsersGuardService] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { 
}


// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/app-routing.module.ts